export const ADD_FIELD_TYPE = 'ADD_FIELD_TYPE';
export const DELETE_FIELD_TYPE = 'DELETE_FIELD_TYPE';
export const EDIT_LIST_VALUE = 'EDIT_LIST_VALUE';